import { Injectable } from '@angular/core';
import { IAddon, IAddonDependency, IGroupedAddon } from '../../interfaces/cart-details.interface';

@Injectable()
export class PrimeAddonsService {

  public prepareAddonsMap(slot: any): void {
    slot._computedFields.addonsMap = this.getAddonsList(slot).reduce((addonsMap: {string?: IAddon}, addon: IAddon) => {
      addon._computedFields = addon._computedFields || {};

      addonsMap[addon.addonCode] = addon;
      return addonsMap;
    }, {});
  }

  public resetAddons(slot: any): void {
    this.getAddonsList(slot).forEach((addon: any) => addon.excludedBy = {});
  }

  public updateAll(slot: any): void {
    this.groupUpdate(slot);

    slot.addons.optional.forEach((addon: IAddon) => this.singleUpdate(addon, slot));
  }

  public singleUpdate(addon: any, slot: any): void {
    addon.dependency.forEach((dependency: IAddonDependency) => {
      const dependentAddon = slot._computedFields.addonsMap[dependency.addonCode];

      if (dependentAddon) {
        dependentAddon.excludedBy[addon.addonCode] = addon._computedFields.tempSelected;

        const isExcluded = !Object.keys(dependentAddon.excludedBy)
          .every(addonCode => !dependentAddon.excludedBy[addonCode]);

        dependentAddon._computedFields.readOnly = isExcluded;
        dependentAddon._computedFields.showStatement = isExcluded;

        if (dependentAddon.addonType === 'PRIME') {
          this.groupUpdate(slot);
        }
      }
    });
  }

  public groupUpdate(slot: any): void {
    const addonGroup = slot.addons.grouped[0] as IGroupedAddon;

    if (!addonGroup) return;

    addonGroup.groupedAddons.forEach((primeAddon: IAddon) => {
      let isSelected = addonGroup._computedFields.tempSelected
        && addonGroup._computedFields.tempSelectedSubAddonCode === primeAddon.addonCode;
      let isDependencySelected = false;

      slot.addons.optional.forEach((addon: IAddon) => {
        if (addon._computedFields.tempSelected) {
          isDependencySelected = !!addon.dependency.find((item: IAddonDependency) => item.addonCode === primeAddon.addonCode);
        }
      });

      if (isSelected && isDependencySelected) {
        addonGroup._computedFields.tempSelectedSubAddonCode = null;
        isSelected = false;
      }

      primeAddon.dependency.forEach((dependency: IAddonDependency) => {
        const dependentAddon = slot._computedFields.addonsMap[dependency.addonCode];

        if (dependentAddon) {
          dependentAddon.excludedBy[primeAddon.addonCode] = isSelected;

          const isExcluded = !Object.keys(dependentAddon.excludedBy)
            .every(addonCode => !dependentAddon.excludedBy[addonCode]);

          dependentAddon._computedFields.readOnly = isExcluded;
          dependentAddon._computedFields.showStatement = isExcluded;
        }
      });

      primeAddon._computedFields.dependencySelected = isDependencySelected;
      primeAddon._computedFields.readOnly = isDependencySelected || !addonGroup._computedFields.tempSelected;
    });

    addonGroup._computedFields.readOnly = addonGroup.groupedAddons.every((primeAddon: IAddon) => {
      return primeAddon._computedFields.dependencySelected;
    });
  }

  private getAddonsList(slot: any): IAddon[] {
    const groupedAddons = slot.addons.grouped.reduce((list: IAddon[], group: IGroupedAddon) => {
      list = list.concat(...group.groupedAddons);

      return list;
    }, []);

    const allAddons = [...groupedAddons, ...slot.addons.optional];

    return allAddons;
  }
}
